var map = {
	"./Slide 1.jpg": 926,
	"./Slide 10.jpg": 8604,
	"./Slide 11.jpg": 2964,
	"./Slide 12.jpg": 8986,
	"./Slide 2.jpg": 452,
	"./Slide 3.jpg": 1027,
	"./Slide 4.jpg": 3448,
	"./Slide 5.jpg": 7438,
	"./Slide 6.jpg": 4629,
	"./Slide 7.jpg": 6239,
	"./Slide 8.jpg": 921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1368;